<div
  class="px-5 py-4 border-secondary"
  [class.border-bottom]="hasBorder"
>
  <div class="position-relative d-flex align-items-center justify-content-between ps-10">
    <app-skeleton-loader [inline]="false" class="position-absolute start-0 w-20px h-20px"></app-skeleton-loader>
    <app-skeleton-loader [inline]="false" class="w-150px h-20px"></app-skeleton-loader>
    <app-skeleton-loader [inline]="false" class="w-60px h-20px"></app-skeleton-loader>
  </div>
</div>
